import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { RoleOption } from '@/types/user';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../requestOptions';

export const getRoleOptions = async (scope: RequestScope, options: ReadRequestOptions): Promise<EndpointResponse<RoleOption[]>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<RoleOption[]>>('/organization/role/options', options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error);
  }
};
